// Utilità condivise dai form di configurazione Colata.

/** "Manutenzione programmata" -> "manutenzione_programmata" (formato richiesto dai vincoli *_key_ck) */
export const slugify = (testo) => String(testo ?? '')
  .normalize('NFD')
  .replace(/[̀-ͯ]/g, '')
  .toLowerCase()
  .replace(/[^a-z0-9]+/g, '_')
  .replace(/^_+|_+$/g, '');

export const CHIAVE_VALIDA = /^[a-z0-9_]+$/;

export const vuoto = (valore) => valore === undefined || valore === null || String(valore).trim() === '';

/** Converte il testo di un input "ordine" in intero (default 0). Ritorna NaN se non valido. */
export const interoOrdine = (valore) => {
  if (vuoto(valore)) return 0;
  const n = Number(valore);
  return Number.isInteger(n) ? n : NaN;
};

// ─── Liste definite dai vincoli CHECK del database (non sono dati) ────────────

export const TIPI_CAMPO = [
  { value: 'testo',     label: 'Testo' },
  { value: 'numero',    label: 'Numero' },
  { value: 'data',      label: 'Data' },
  { value: 'booleano',  label: 'Sì / No' },
  { value: 'selezione', label: 'Selezione (elenco)' },
];


// Comportamenti di un tipo di intervento: 'nessuno' = tipo_movimento NULL (non cambia la giacenza)
export const COMPORTAMENTI = [
  { value: 'sostituzione', label: 'Sostituzione — scarica la giacenza (−)' },
  { value: 'rientrato',    label: 'Rientrato — carica la giacenza (+)' },
  { value: 'nessuno',      label: 'Nessuna variazione (es. Ordinato)' },
];

export const DECIMALI = [
  { value: '0', label: '0 — numeri interi (pezzi)' },
  { value: '1', label: '1 decimale' },
  { value: '2', label: '2 decimali (es. metri)' },
  { value: '3', label: '3 decimali' },
];
